import React from 'react';
import Support from '../../shared/Support';
import { server } from '../../../constants/SiteVariables';

export default function UserIsNotBorrower() {
  return (
    <div className="has-text-centered" id="content">
      <h1 className="title">Your Account Is Not Authorized</h1>
      <p className="mb-4">Your account is not authorized as a borrower with Credit Key.</p>
      <p>You may still login at: <a href={server()} className="has-text-weight-bold">creditkey.com</a></p>

      <Support />
    </div>
  )
}
